import { useEffect, useMemo, useState } from "react";
import { renderMarkdownToHtml } from "../../../documentation/renderMarkdown";
import { Loading } from "../../elements/Loading";
import { HelpDocument } from "./useHelpDocuments";

export function HelpDocumentBody({
  document,
  perspective,
}: {
  document: HelpDocument;
  perspective: string;
}) {
  const [markdown, setMarkdown] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;

    async function load() {
      try {
        setError("");
        setMarkdown("");
        const response = await fetch(document.href);
        const text = await response.text();

        if (!cancelled) {
          setMarkdown(text);
        }
      } catch {
        if (!cancelled) {
          setError("Unable to load this help document.");
        }
      }
    }

    load();

    return () => {
      cancelled = true;
    };
  }, [document.href]);

  const html = useMemo(
    () =>
      markdown
        ? renderMarkdownToHtml(markdown, {
            documentationPerspective: perspective,
            resolveAssetUrl: (src: string) =>
              document.imageMap[src] || src,
          })
        : "",
    [document.imageMap, markdown, perspective]
  );

  if (error) {
    return <div className="alert alert-danger mb-0">{error}</div>;
  }

  if (!html) {
    return <Loading className="spinner-border m-5" />;
  }

  return (
    <article className="lh-lg" dangerouslySetInnerHTML={{ __html: html }} />
  );
}
